/* eslint-disable react/forbid-elements */
import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeExternalLinks from 'rehype-external-links';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

export type DisplayMarkdownProps = {
    markdown?: string | undefined;
};
export function DisplayMarkdown(props: DisplayMarkdownProps) {
    return (
        <div className="markdown-table">
            <ReactMarkdown
                remarkPlugins={[remarkGfm as never]}
                rehypePlugins={[rehypeRaw, [rehypeExternalLinks, { target: '_blank', rel: 'noopener noreferrer' }]]}
            >
                {props.markdown ?? ''}
            </ReactMarkdown>
        </div>
    );
}
